import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mayuculaEspaciosRepse'
})
export class MayusculaEspaciosRepsePipe implements PipeTransform {


    transform(texto: string): string | number {
        if (!texto) return '...'



        const documentosLegales = [
            {
                nombre: "Acta Constitutiva",
                descripcion: "Instrumento de constitución de la empresa",
                entidad: "Proveedor especializado",
                nombreRepse: "repse-acta-constitutiva"
            },
            {
                nombre: "Poder",
                descripcion: "Instrumento que acredita la representación legal",
                entidad: "Proveedor especializado",
                nombreRepse: "repse-poder"
            },
            {
                nombre: "Identificación",
                descripcion: "Identificación oficial del representante legal o persona física",
                entidad: "Proveedor especializado",
                nombreRepse: "repse-identificacion"
            },
            {
                nombre: "Correo del Firmante",
                descripcion: "Correo de contacto del representante legal",
                entidad: "Proveedor especializado",
                nombreRepse: "repse-correo"
            },
            {
                nombre: "Cédula Fiscal",
                descripcion: "Comprobante expedido por el SAT en donde se ve los datos de la empresa o persona física",
                entidad: "Proveedor especializado",
                nombreRepse: "repse-cedula-fiscal"
            },
            {
                nombre: "Comprobante de Domicilio",
                descripcion: "Documento en donde se ve el domicilio fiscal igual a la cédula fiscal",
                entidad: "Proveedor especializado",
                nombreRepse: "repse-comprobante-domicilio"
            },
            {
                nombre: "REPSE",
                descripcion: "Documento que credite que cumplimos los requisitos ante la STPS para ser proveedor especializado",
                entidad: "Proveedor especializado",
                nombreRepse: "repse-repse"
            },
            {
                nombre: "Fianza",
                descripcion: "No proporcionada en la imagen",
                entidad: "Proveedor especializado",
                nombreRepse: "repse-fianza"
            },
            {
                nombre: "Contrato",
                descripcion: "No proporcionada en la imagen",
                entidad: "Proveedor especializado",
                nombreRepse: "repse-contrato"
            },
            {
                nombre: "Pago de Impuesto sobre Nómina ISN",
                descripcion: "Documento bancario en donde se refleje el pago del ISN del mes de servicio",
                entidad: "Secretaría de Finanzas",
                area: "Local",
                nombreRepse:"repse-pago-isn"
            },
            {
                nombre: "Comprobante de Pago ISN",
                descripcion: "Documento emitido por la SF en donde se ve el importe a pagar con línea de captura",
                entidad: "SF",
                area: "Local",
                nombreRepse:"repse-comprobante-pago-isn"
            },
            {
                nombre: "32 D SAT Positivo",
                descripcion: "Documento emitido por el SAT en donde se refleje que está al corriente con sus obligaciones fiscales",
                entidad: "SAT",
                area: "Local",
                nombreRepse:"repse-32d-sat-positivo"
            },
            {
                nombre: "Declaración de Impuestos ISR Retenido por Salarios",
                descripcion: "Documento emitido por el SAT en donde se ve el importe a pagar con línea de captura",
                entidad: "SAT",
                area: "Local",
                nombreRepse:"repse-declaracion-impuestos-isr"
            },
            {
                nombre: "Comprobante de Pago de ISR Retenido por Salarios",
                descripcion: "Documento bancario en donde se refleje el pago del ISR Retenido por salarios del mes de servicio",
                entidad: "Banco",
                area: "Local",
                nombreRepse:"repse-comprobante-pago-isr"
            },
            {
                nombre: "Declaración de Impuesto IVA",
                descripcion: "Documento emitido por el SAT en donde se ve el importe de IVA a pagar con línea de captura",
                entidad: "SAT",
                area: "Local",
                nombreRepse:"repse-declaracion-impuesto-iva"
            },
            {
                nombre: "Comprobante de Pago de IVA",
                descripcion: "Documento bancario en donde se refleje el pago de IVA del mes de servicio",
                entidad: "Banco",
                area: "Local",
                nombreRepse:"repse-comprobante-pago-iva"
            },
            {
                nombre: "32 D Infonavit Positivo",
                descripcion: "Documento emitido por el INFONAVIT en donde se refleje que está al corriente con sus obligaciones de Infonavit",
                entidad: "Infonavit",
                area: "Local",
                nombreRepse:"repse-32d-infonavit-positivo"
            },
            {
                nombre: "CFDI Infonavit",
                descripcion: "Documento emitido por el INFONAVIT",
                entidad: "Infonavit",
                formato: "XML",
                area: "Local",
                nombreRepse:"repse-cfdi-infonavit"
            },
            {
                nombre: "32 D IMSS Positivo",
                descripcion: "Documento emitido por el IMSS en donde se refleje que está al corriente con sus obligaciones de seguridad social",
                entidad: "IMSS",
                area: "Local",
                nombreRepse:"repse-32d-imss-positivo"
            },
            {
                nombre: "Determinación de Prima de Riesgo Vigente",
                descripcion: "No proporcionada en la imagen",
                entidad: "IMSS",
                area: "Local",
                nombreRepse:"repse-determinacion-prima-riesgo"
            },
            {
                nombre: "SIPARE",
                descripcion: "No proporcionada en la imagen",
                entidad: "IMSS",
                area: "Local",
                nombreRepse:"repse-sipare"
            },
            {
                nombre: "Comprobante de Pago SIPARE",
                descripcion: "No proporcionada en la imagen",
                entidad: "IMSS",
                area: "Local",
                nombreRepse:"repse-comprobante-pago-sipare"
            },
            {
                nombre: "Liquidación SUA Mensual",
                descripcion: "No proporcionada en la imagen",
                entidad: "IMSS",
                area: "Local",
                nombreRepse:"repse-liquidacion-sua-mensual"
            },
            {
                nombre: "Liquidación SUA Bimestral",
                descripcion: "No proporcionada en la imagen",
                entidad: "IMSS",
                area: "Local",
                nombreRepse:"repse-liquidacion-sua-bimestral"
            },
            {
                nombre: "Lista de Nómina Pagada",
                descripcion: "No proporcionada en la imagen",
                entidad: "IMSS",
                area: "Local",
                nombreRepse:"repse-lista-nomina-pagada"
            },
            {
                nombre: "SIRCO",
                descripcion: "No proporcionada en la imagen",
                entidad: "IMSS",
                area: "Local",
                nombreRepse:"repse-sirco"
            },
            // {
            //     nombre: "ISCOE",
            //     descripcion: "No proporcionada en la imagen",
            //     entidad: "IMSS",
            //     area: "Local",
            //     nombreRepse:"repse-iscoe"
            // },
            // {
            //     nombre: "SISUB",
            //     descripcion: "No proporcionada en la imagen",
            //     entidad: "IMSS",
            //     area: "Local",
            //     nombreRepse:"repse-sisub"
            // },
            //estos tiene validacion por servicio ocr

            {
                nombre: "Acuse de recibo declaraciones provisional o definitiva de impuestos de federales",
                nombreRepse: "repse-acuse-recibo",
                datos: {
                    RFC: "Valor",
                    DenominaciOnSocial: "Valor",
                    periodo: "Valor",
                    ejercicio: "Valor"
                }
            },
            {
                nombre: "Autorizacion de la Secretaria del Trabajo",//completo
                nombreRepse: "repse-autorizacion-trabajo",
                datos: {
                    RFC: "Valor",
                    DenominaciónSocial: "Valor",
                    fecha: "Valor"
                }
            },
            {
                nombre: "Confirmacion contribuciones IMSS",//
                nombreRepse: "repse-confirmacion-imss",
                datos: {
                    RFC: "Valor",
                    DenominaciónSocial: "Valor",
                    fecha: "Valor"
                }
            },
            {
                nombre: "Confirmacion Contribuciones INFONAVIT",//
                nombreRepse: "repse-confirmacion-infonavit",
                datos: {
                    RFC: "Valor",
                    DenominaciónSocial: "Valor",
                    fecha: "Valor"
                }
            },
            {
                nombre: "Confirmacion contribuciones SAT",//
                nombreRepse: "repse-confirmacion-sat",
                datos: {
                    RFC: "Valor",
                    DenominaciónSocial: "Valor",
                    fecha: "Valor"
                }
            },
            {
                nombre: "Declaracion Provisional o definitiva de impuestos federales",//
                nombreRepse: "repse-declaracion-impuestos",
                datos: {
                    RFC: "Valor",
                    DenominaciónSocial: "Valor",
                    ISRretenido: "Valor"
                }
            },
            {
                nombre: "Factura de prestacion de servicios",//
                nombreRepse: "repse-factura-servicios",
                datos: {
                    RFC: "Valor",
                    DenominaciónSocial: "Valor",
                    IVAtrasladado: "Valor"
                }
            },
            {
                nombre: "Informacion de pagos federales",
                nombreRepse: "repse-informacion-pagos",
                datos: {
                    RFC: "Valor",
                    DenominaciónSocial: "Valor",
                    Periodo: "Valor",
                    IVAtrasladado: "Valor",
                    ImporteIVApagado: "Valor"
                }
            },
            {
                nombre: "Acuse cuatrimestrales INFONAVIT (SISUB)",
                nombreRepse: "repse-sisubb",
                datos: {
                    RFC: "IEE1108011K8",
                    denominación: "Valor",
                    NúmeroDeContrato: "Valor",
                    Cuatrimestre: "Valor",
                    NúmeroDeRegistrosPatronalesRecibidos: 1,
                    NúmeroDeTrabajadoresRelacionados: "Valor",
                    FechaDeCarga: "Valor"
                }
            },
            {
                nombre: "Acuses cuatrimestrales IMSS (ICSOE)",
                nombreRepse: "repse-icsoee",
                datos: {
                    RFC: "Valor",
                    DenominacionSocial: "Valor",
                    fecha: "Valor",
                    año: "Valor",
                    cuatrimestre: "Valor"
                }
            }






        ];








        //encuentra texto en el array de documentos legales en la propiedad nombreRepse y devuelve el nombre
        let documento = documentosLegales.find(doc => doc.nombreRepse === texto);


        if (documento) {
           // console.log(documento.nombre.toLocaleUpperCase());
            return documento.nombre.toLocaleUpperCase();
        } else {
            //console.log("no encontro", texto);
            let separado = texto;
            texto.split('').filter(element => element === '_').map(res => {
                separado = separado.replace("_", " ");
            })
            let ultimo = separado.replace(separado.charAt(0), separado.charAt(0).toUpperCase());
            return ultimo

        }




    }
}